"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorialInfo = void 0;
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const EditorialInfo = ({
  authorName,
  publishedDate,
  photographerName
}) => {
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const formattedPublishedDate = (0, _culture.useFormatDate)(new Date(publishedDate ?? ''), _culture.DateFormat.ShortDate, {
    toLocalTimezone: true
  });
  if (!publishedDate && !authorName && !photographerName) {
    return null;
  }
  const editorialInfo = [publishedDate ? `${translations.published}:\u00A0${formattedPublishedDate}` : null, authorName ? `${translations.author}:\u00A0${authorName}` : null, photographerName ? `${translations.photo}:\u00A0${photographerName}` : null].filter(Boolean).join('  |  ');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.EDITORIAL_INFO),
    children: editorialInfo
  });
};
exports.EditorialInfo = EditorialInfo;
